/**
 * AdditionalStats - Extra season statistics
 */
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { BarChart3 } from 'lucide-react';

export function AdditionalStats({ stats }) {
  if (!stats.total_matches) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BarChart3 className="w-5 h-5 text-emerald-600" strokeWidth={1.5} />Additional Statistics
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 text-center">
          <div className="p-3 sm:p-4 bg-gray-50 rounded-xl">
            <p className="text-xl sm:text-2xl font-bold text-gray-900">{stats.goals_per_game || 0}</p>
            <p className="text-xs sm:text-sm text-gray-500">Goals/Game</p>
          </div>
          <div className="p-3 sm:p-4 bg-gray-50 rounded-xl">
            <p className="text-xl sm:text-2xl font-bold text-gray-900">{stats.conceded_per_game || 0}</p>
            <p className="text-xs sm:text-sm text-gray-500">Conceded/Game</p>
          </div>
          <div className="p-3 sm:p-4 bg-gray-50 rounded-xl">
            <p className="text-xl sm:text-2xl font-bold text-indigo-600">{stats.unique_starters || 0}</p>
            <p className="text-xs sm:text-sm text-gray-500">Different Starters</p>
          </div>
          <div className="p-3 sm:p-4 bg-gray-50 rounded-xl">
            <p className="text-xl sm:text-2xl font-bold text-teal-600">{stats.players_with_appearance || 0}</p>
            <p className="text-xs sm:text-sm text-gray-500">Players Used</p>
          </div>
          <div className="p-3 sm:p-4 bg-gray-50 rounded-xl col-span-2 sm:col-span-1">
            <p className="text-xl sm:text-2xl font-bold text-gray-900">{stats.total_players || 0}</p>
            <p className="text-xs sm:text-sm text-gray-500">Squad Size</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
